module.exports = __webpack_public_path__ + "img/CovidSector_Infographics_20.bc3ddc8b.png";